import {VolumeFilterTypes} from '@ozark/functions/src/functions/express/private/types/Reports';
import {FilterOption} from '../../Filters';

export const RejectsFilters: FilterOption[] = [
  {
    id: 'mid',
    column: 'mid',
    label: 'MID',
    type: 'text',
    force: true,
    operators: [
      {
        id: '__eq',
        label: 'equals',
      },
    ],
  },
  {
    id: 'groupId',
    column: 'groupId',
    label: 'Group',
    type: 'text',
    force: true,
    operators: [
      {
        id: '__eq',
        label: 'equals',
      },
    ],
  },
  {
    id: 'agentId',
    column: 'agentId',
    label: 'Agent',
    type: 'text',
    force: true,
    operators: [
      {
        id: '__eq',
        label: 'equals',
      },
    ],
  },
  // ticket status
  {
    id: 'collectionMethod',
    column: 'collectionMethod',
    label: 'Collection Method',
    type: 'text',
    operators: [
      {
        id: '__eq',
        label: 'equals',
      },
    ],
  },

  {
    id: 'rejectCode',
    column: 'rejectCode',
    label: 'ACH Reject Code',
    type: 'text',
    operators: [
      {
        id: '__eq',
        label: 'equals',
      },
    ],
  },
  {
    id: 'rejectDate',
    column: 'rejectDate',
    label: 'ACH Reject Date',
    type: 'dateOnlyRange',
    defaultDateRange: VolumeFilterTypes.All,
    operators: [
      {
        id: '__between',
        label: 'is between',
      },
    ],
  },
];
